import { useLocation } from 'react-router-dom';

export const SKIP_AUTO_POPUPS_STATE_KEY = 'skipAutoPopups';

export type SkipAutoPopupsState = {
  [SKIP_AUTO_POPUPS_STATE_KEY]?: boolean;
};

export type SkipAutoPopupsLocation = {
  pathname: string;
  search: string;
  hash: string;
  state: SkipAutoPopupsState;
};

function parseLocationPath(to: string): Pick<SkipAutoPopupsLocation, 'pathname' | 'search' | 'hash'> {
  const hashIndex = to.indexOf('#');
  const hash = hashIndex >= 0 ? to.slice(hashIndex) : '';
  const withoutHash = hashIndex >= 0 ? to.slice(0, hashIndex) : to;
  const searchIndex = withoutHash.indexOf('?');
  const search = searchIndex >= 0 ? withoutHash.slice(searchIndex) : '';
  const pathname = searchIndex >= 0 ? withoutHash.slice(0, searchIndex) : withoutHash;

  return { pathname, search, hash };
}

function readSkipAutoPopups(state: unknown): boolean {
  if (!state || typeof state !== 'object') return false;
  return (state as SkipAutoPopupsState)[SKIP_AUTO_POPUPS_STATE_KEY] === true;
}

/**
 * Yönlendirme hedefine "otomatik popup açma" niyetini URL'ye yazmadan history.state ile taşır.
 * Mevcut state varsa merge edilir.
 */
export function withSkipAutoPopups(to: string, extraState?: Record<string, unknown>): SkipAutoPopupsLocation {
  return {
    ...parseLocationPath(to),
    state: {
      ...extraState,
      [SKIP_AUTO_POPUPS_STATE_KEY]: true,
    },
  };
}

/**
 * Hedef sayfada otomatik popup'ların bastırılıp bastırılmayacağını döner.
 * Yeni bir popup eklerken açmadan önce bu hook'u kontrol et.
 */
export function useSkipAutoPopups(): boolean {
  const location = useLocation<SkipAutoPopupsState | undefined>();
  return readSkipAutoPopups(location.state);
}
